import { render, staticRenderFns } from "./ProductRating.vue?vue&type=template&id=55056b42&"
import script from "./ProductRating.vue?vue&type=script&lang=js&"
export * from "./ProductRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports